export default __webpack_public_path__ + "static/media/pt_diameter.c470d727.svg";